import { render, staticRenderFns } from "./ar.vue?vue&type=template&id=be3d32b8&scoped=true&lang=html"
import script from "./ar.vue?vue&type=script&lang=js"
export * from "./ar.vue?vue&type=script&lang=js"
import style0 from "./ar.vue?vue&type=style&index=0&id=be3d32b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3d32b8",
  null
  
)

export default component.exports